"use client";

import { c as _c } from "react/compiler-runtime";
import { FixedBottomSheet, FixedBottomSheetBody, FlexCenter, FlexColumn, SpaceBetween } from "@opensea/ui-kit";
import { useScrollDirection } from "@opensea/ui-kit/hooks";
import { useShallow } from "zustand/react/shallow";
import { bottomFixedVariants } from "@/styles/utils/bottom-fixed";
import { useProfileTokensSelectionStore } from "../ProfileTokensSelectionProvider";
import { ProfileTokensSelectionClearAll } from "./ProfileTokensSelectionClearAll";
import { ProfileTokensSelectionPreview } from "./ProfileTokensSelectionPreview";
import { TokenHideButton } from "./TokenHideButton";
export function MobileProfileTokensActionBar(t0) {
  const $ = _c(11);
  const {
    onRefetch
  } = t0;
  const [selectedTokensMap] = useProfileTokensSelectionStore(useShallow(_temp));
  const {
    isTopOfPage,
    scrollDirection
  } = useScrollDirection();
  const isScrolledUp = isTopOfPage || scrollDirection === "up";
  const hasSelectedTokens = selectedTokensMap.size > 0;
  if (!hasSelectedTokens) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = bottomFixedVariants();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isScrolledUp || hasSelectedTokens;
  let t3;
  if ($[1] !== selectedTokensMap.size) {
    t3 = selectedTokensMap.size > 0 && <SpaceBetween className="w-full"><ProfileTokensSelectionPreview /><ProfileTokensSelectionClearAll /></SpaceBetween>;
    $[1] = selectedTokensMap.size;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onRefetch) {
    t4 = <FlexCenter className="w-full gap-3"><TokenHideButton onRefetch={onRefetch} /></FlexCenter>;
    $[3] = onRefetch;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <FixedBottomSheetBody className="gap-4 pb-[calc(var(--ios-inset-bottom)+theme(spacing.4))]"><FlexColumn className="w-full gap-3">{t3}{t4}</FlexColumn></FixedBottomSheetBody>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className="h-[108px]"><FixedBottomSheet className={t1} open={t2}>{t5}</FixedBottomSheet></div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(v) {
  return [v.selectedTokensMap];
}